/**
 * Evalúa permisos basados en la configuración del rol.
 * Control visual de la interfaz, no seguridad.
 * Si el módulo o la acción no existen, se permite el acceso.
 */
export const hasPermission = (role, module, action) => {
  if (!role) return false;

  if (role.id === 1) return true;

  const config = role.config;

  if (!config || typeof config !== "object") return true;

  const moduleConfig = config[module];

  if (!moduleConfig) return false;

  if (moduleConfig[action] === undefined) return false;

  return Boolean(moduleConfig[action]);
};

/**
 * Evalúa si el rol tiene al menos uno de los permisos indicados.
 * Si el módulo o una acción no existen, se consideran permitidos.
 */
export const hasAnyPermission = (role, module, actions = []) => {
  if (!role) return false;

  if (role.id === 1) return true;

  const config = role.config;

  if (!config || typeof config !== "object") return true;

  const moduleConfig = config[module];

  if (!moduleConfig) return false;

  return actions.some((action) => {
    if (moduleConfig[action] === undefined) return false;
    return Boolean(moduleConfig[action]);
  });
};
